var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('tab-navbar',{staticClass:"mb-4",attrs:{"options":_vm.tabs}}),_c('b-card',{staticClass:"dashboard-card shadow-sm mr-t-4"},[_c('router-view',{on:{"handleSave":_vm.changeTab}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }